import { render, staticRenderFns } from "./ListUser.vue?vue&type=template&id=64d960d1&"
import script from "./ListUser.vue?vue&type=script&lang=js&"
export * from "./ListUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports